import * as ng from 'angular';
import { ComponentRegistration, ISiteConfigService } from '../../core';
import { ISessionService, IToastMessageService, ICustomerSettingsService } from '../../services';
import * as Core from '../../core';
import { IProfileResource, Dto } from '../../data';
let template = require('./profile.html');

class ProfileComponent extends ComponentRegistration {

    constructor() {
        super('profile', {
            controller: ProfileController,
            templateUrl: template,
            controllerAs: 'profile',
            bindings: {
            }
        });
    }
}

interface IProfileController {
    activate(): void;
    onCancel(args): void;
    onSave(args): void;
    onEdit(args): void;
    setFormReadOnly(): void;
    loadAccount(accountId): void;
    savePrimaryContact(args): void;
}

class ProfileController implements IProfileController {
    private static $inject: Array<string> = ['$scope', '$window', '$rootRouter', 'Session', 'SiteConfig',
        'toastMessageFactory', 'Profile', 'CustomerSettings'];

    private sessionRef: any = {};
    private oriProfile: Dto.IProfile = {} as Dto.IProfile;
    private profile: Dto.IProfile = {} as Dto.IProfile;

    private isReadOnly: Boolean = true;
    private isSideNavOpen: Boolean = false;
    private languages: Array<Core.ILanguage> = [];

    constructor(private $scope: ng.IScope,
        private $window: ng.IWindowService,
        private $router: ng.Router,
        private Session: ISessionService,
        private SiteConfig: ISiteConfigService,
        private toastMessageFactory: IToastMessageService,
        private Profile: IProfileResource,
        private CustomerSettings: ICustomerSettingsService) {

        this.activate();

    }

    public activate(): void {
        console.log('ProfileController loaded');
        this.setFormReadOnly();
        this.loadAccount();
        console.log('ProfileController activated');
    }

    public onCancel(args): void {
        this.profile = ng.copy(this.oriProfile);
        this.sessionRef.profile = this.profile;
        (this.$scope as any).profileForm.$setPristine();
        this.setFormReadOnly();
    }

    public onSave(args): void {
        this.savePrimaryContact(args);
    }

    public onEdit(args): void {
        this.isReadOnly = false;
    }

    public setFormReadOnly(): void {
        this.isReadOnly = true;
    }

    public loadAccount(accountId?: string): void {

        let sessionHandler = (session) => {
            this.sessionRef = session;
            this.profile = ng.copy(session.profile);
            this.oriProfile = session.profile;
        };

        this.Session.registerRefreshHandler(sessionHandler);
        this.Session.getSessionAsync()
            .then(sessionHandler);

        this.CustomerSettings.getLanguageSettings().then((languageSettings) => {
            this.languages = languageSettings.languages;
        });

        //this.SiteConfig.getConfigAsync()
        //    .then((config) => {
        //        this.languages = config.languages;

        //    });
    }

    public savePrimaryContact(args): ng.IPromise<void> {
        this.setFormReadOnly();

        return this.Profile.update({ id: this.profile.id, accountId: this.profile.accountId }, this.profile)
            .$promise
            .then((response) => {
                this.sessionRef.profile = response;
                this.profile = ng.copy(this.sessionRef.profile);
                this.Session.setLanguage(this.profile.language);
                this.toastMessageFactory.showSuccessMessage();
                console.log("Profile Save Successful");
            })
            .catch((e) => {
                args.cancel();
                this.isReadOnly = false;
                console.log(e);
            });
    }
}

let prflComponent = new ProfileComponent();
export default prflComponent;
export { prflComponent as ProfileComponent, IProfileController, ProfileController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/profile/profile.ts